<template>
  <div class="header-containre">
    <!--    <img class="lianxi" @click="gotoUrl()" src="@/assets/images/lianxi.png" alt="">-->
    <img class="back" @click="goBack()" src="@/assets/images/back.png" alt="" />
  </div>
</template>
<script>
// import {$subscriber } from "fire-wind-water";
import { browerType } from "../common/sbase";

export default {
  name: "Banner",
  data() {
    return {
      extras: {},
      browerType: browerType
    };
  },
  created() {
    // $subscriber.subscribe("config-loaded", res=>{
    //   this.extras = res;
    // });
  },
  methods: {
    gotoUrl() {
      window.open("https://jlg-wz.smarket.com.cn/home/contact");
    },
    goBack() {
      history.back();
    }
    //    openUrl() {
    //      if(this.bannerHref && (this.bannerHref.indexOf('http://') == 0 || this.bannerHref.indexOf('https://') == 0)){
    //        window.open(this.bannerHref);
    //      }
    //    }
  },
  components: {}
};
</script>
